export const StickyFunction = () => {
  $(function() {
    return $("[data-sticky_column]").stick_in_parent({
      parent: "[data-sticky_parent]",
      offset_top: 97
    });
  });
  let window_width = jQuery(window).width();
  if (window_width < 768) {
    $("[data-sticky_column]").trigger("sticky_kit:detach");
  }

  let dd = document.getElementsByClassName("dropdown-menu");
  for (let index = 0; index < dd.length; index++) {
    // dd[index].addEventListener('click', e => e.stopPropagation())
  }

  $(document.body).on("click", ".dropdown-menu.show .checkbox-styled", function(
    e
  ) {
    if ($("#hostRadio").prop("checked")) {
      $(this)
        .parents(".dropdown-menu")
        .removeClass("show");
    } else if ($("#contestRadio").prop("checked")) {
      $(this)
        .parents(".dropdown-menu")
        .removeClass("show");
    }
  });

  $(".searchbox .form-group input").change(function() {
    if ($(this).val() != "") {
      $(this).addClass("filled");
    } else {
      $(this).removeClass("filled");
    }
  });

  $(".searchbox .form-group input").each(function() {
    if ($(this).val() != "") {
      $(this).addClass("filled");
    } else {
      $(this).removeClass("filled");
    }
  });

  $(".searchbox .form-control")
    .focus(function() {
      $(this)
        .parent()
        .addClass("focused");
    })
    .blur(function() {
      $(this)
        .parent()
        .removeClass("focused");
    });

  $(document).on("click", function(e) {
    var menu_opened = $("#main-navigation").hasClass("show");
    if (
      !$(e.target).closest("#main-navigation").length &&
      !$(e.target).is("#main-navigation") &&
      menu_opened === true
    ) {
      $("#main-navigation").removeClass("show");
    }
  });
};
